
import { AppFullscreen } from "quasar";
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "LayoutDefault",

  components: {
    HelloWorld,
  },

  data() {
    return {
      leftDrawerOpen: false,
      text: "",
      dense: true,
    };
  },
  methods: {},
  computed: {
    checkLogin() {
      if (this.$route.name === "login") {
        return true;
      } else {
        return false;
      }
    },
  },
};
